import { render, staticRenderFns } from "./SimpleSubStory.vue?vue&type=template&id=258744b5&scoped=true&"
import script from "./SimpleSubStory.vue?vue&type=script&lang=js&"
export * from "./SimpleSubStory.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSubStory.vue?vue&type=style&index=0&id=258744b5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258744b5",
  null
  
)

export default component.exports